import getDayMonthYear from "./getDayMonthYear";

export default function getStartAndEndDate(m, y) {
    let date = new Date(y, m, 0);
    const { day, month, year } = getDayMonthYear(date);
    let start = year + "-" + month + "-01";
    let end = year + "-" + month + "-" + day + "T23:59:59";
    return { start, end };
}
